import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=b98f3ff4&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutos.vue?vue&type=style&index=0&id=b98f3ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98f3ff4",
  null
  
)

export default component.exports